import { css, html } from 'lit'
import { customElement, property, state, query } from 'lit/decorators.js'
import { ParentPico } from '../parent-pico/parent-pico.ts'

/**
 * An example element.
 *
 * @slot - This element has a slot
 * @csspart button - The button
 */
@customElement('hyper-select-pico')
export class HyperSelectPico extends ParentPico {


  @state() _selected = -1;

  @state() _detailsOpen = false;

  @property() placeholder = "Select";

  @property({ type: Boolean }) disabled: Boolean = false;

  @property({ type: Array }) items: string[] = [];

  @property({ type: String }) value: string = "";

  @property({ type: String }) invalid: string = "";

  @property({ type: String }) invalidMessage: string = " ";



  @query("#searchfilter")
  input!: HTMLInputElement

  cid: string = "detail_" + Math.floor(Math.random() * 1000);


  @query("details")
  details!: HTMLDetailsElement;

  _originalList: string[] = [];

  _filterFlag: boolean = true;


  connectedCallback(): void {
    super.connectedCallback();
    this._selected = this.items?.indexOf(this.value);
    this.addEventListener('focusout',
      () => (this.details.open) ? this.details.toggleAttribute('open') : '');

  }

  private _selectThing(index: number) {
    this._selected = index;
    this.input.value = this.items[index];
    this.value = this.items[index];
    this.details.toggleAttribute('open');
    this.dispatchEvent(new CustomEvent(this.placeholder, {
      bubbles: true,
      composed: true,
      detail: { value: this.value }
    }));
  }

  private _filteredItems(event: Event) {
    if (this.items?.length > 0) {
      const input = event.target as HTMLInputElement;
      if (this._originalList.length == 0)
        this._originalList = this.items;
      this._filterFlag = false;
      this.items = this._originalList.filter(x => x.toLowerCase().includes(input.value.toLowerCase()));
    }
  }

  updated(changedProperties: Map<string | number | symbol, unknown>): void {
    super.updated(changedProperties);
    if (changedProperties.has('items') && this._filterFlag) {
      this._selected = -1;
      this.input.value = "";
    }
  }
  // .value=${(this.items?.length>0 && this._selected>0)?this.items[this._selected]:this.placeholder} 
  render() {
    return html`
          <!-- Dropdown -->
          <section>
          
          <input 
          autocomplete="off"
          type="text" 
          tabIndex=-1 
          id="searchfilter"
          class=" ${(this.disabled ? 'disabled' : '')}" 
          @input="${this._filteredItems}" @focus="${() => ((!this.details.open) ? this.details.toggleAttribute('open') : '')}"
          name="items" 
          placeholder="${this.placeholder}"
          aria-invalid="${this.invalid}"
          />
        
          <details  class="dropdown">
            <summary></summary>
            <ul>
                ${this.items?.map((item, i) => html`
                <li  @click=${() => this._selectThing(i)} for="${i}">
                     <a href="#"> ${item} </a>
                  </li>
                  `)}
              </ul>
          </details>
          <section>

          `
  }


  static styles = [
    ParentPico.styles,
    css`
    input {
      margin-bottom:0;
      }

    small{
    padding-left: .2rem;
    }

    #searchfilter{
      position:relative;
       z-index:2; 
      background-color:transparent;
      flex-grow:2;
      background-image: none;
      border-width:2.5px;
      width:100%;
      
    }
    
    

    details {
      position: relative;
      margin-top: calc(-1*(1rem* var(--pico-line-height) + var(--pico-form-element-spacing-vertical)* 3 + var(--pico-border-width)* 6));
      max-height: 400px;
      flex-grow: 2;
      width: 100%;
    }

    details ul {
      width: 100%;
      max-height: 300px;
      overflow-y: auto;
      box-sizing: border-box;
 flex-grow: 2;
      padding: 0;
      margin: 0;
      list-style: none;    }
      

    details.dropdown summary+ul li {
      width: 100%;
      box-sizing: border-box;
      list-style: none;
      padding:1rem;
      margin:auto;
    }

    details.dropdown summary+ul li a {
      box-sizing: border-box;
      display: block;
      padding: 0.5rem 1rem;
      color: inherit;
      word-wrap: break-word;
      overflow-wrap: break-word;
      hyphens: auto;
      text-decoration: none;
      white-space: normal;
      line-height: 1.4;
      cursor: pointer;
      width:100%
      transition: background-color 0.2s ease;

    }

    @media(min-width:768px){
    :host{
    flex:1;
    min-width:45%;
    }

    section{
    flex:1;
    width:100%;
   

    }

    }

    
   
  
    
    `
  ];


}

declare global {
  interface HTMLElementTagNameMap {
    'hyper-select-pico': HyperSelectPico
  }
}
